import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { fetchOnlyData } from "../../utility/superAdminApi";
import CancelIcon from "@mui/icons-material/Cancel";
import loaderImg from "../../assets/loader.webp";

const INITIAL_LIMIT = 5;

function LicenseTable({ data, className }) {
  const [loader, setLoader] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [modal, setModal] = useState(false);
  const [serviceFee, setServiceFee] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const MonthlyFee = useMutation({
    mutationFn: (id) =>
      fetchOnlyData(`/api/superadmin/companies/service-fee/${id}`),
    onSuccess: (response) => {
      setLoader(false);
      // setModal(true);
      setServiceFee(response);
    },
  });

  const handleClick = (companyData) => {
    setModal(true);
    setLoader(true);
    setCompanyDetails(companyData);
    MonthlyFee.mutate(companyData.id);
  };
  if (!Array.isArray(data)) {
    return <p>No data available</p>; // Or a loading state, based on your preference
  }

  const visibleData = expanded ? data : data?.slice(0, INITIAL_LIMIT);

  return (
    <div>
      <table className="min-w-full">
        <thead>
          <tr
            className={`${data?.length > 0 ? "border-b border-gray-300" : ""}`}
          >
            <th className={`py-2 ${data?.length > 0 ? "" : ""}`}>#</th>
            <th className="py-2">Company Name</th>
            <th className="py-2">Company Email</th>
            <th className="py-2">Date</th>
          </tr>
        </thead>
        <tbody>
          {visibleData?.length > 0 ? (
            visibleData.map((item, index) => (
              <tr
                className="cursor-pointer hover:bg-gray-600"
                key={item?.id}
                onClick={() => handleClick(item)}
              >
                <td className="py-2 text-center border-b border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 text-center border-b border-gray-300">
                  {item?.company_name}
                </td>
                <td className="py-2 text-center border-b border-gray-300">
                  {item?.company_email}
                </td>
                <td
                  className={`py-2 text-center border-b border-gray-300 ${className}`}
                >
                  {item?.license_duration}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="py-4 text-center text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {data?.length > INITIAL_LIMIT && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-3 text-sm text-blue-400 hover:text-blue-300 transition-colors"
        >
          {expanded ? `Show less ▲` : `Show all ${data.length} ▼`}
        </button>
      )}

      {modal && (
        <div className="fixed inset-0 flex justify-center items-start bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-4  my-12">
            {loader ? (
              <div className="flex h-full justify-center align-center">
                <img src={loaderImg} alt="loader" className="w-4" />
              </div>
            ) : (
              <div>
                {" "}
                <div className="flex justify-end">
                  <CancelIcon
                    onClick={() => setModal(false)}
                    className="cursor-pointer text-black mb-2"
                  />
                </div>
                <h2 className="text-black text-center font-bold py-2">
                  Company Details
                </h2>
                <div className="text-black grid grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label htmlFor="">Name:</label>
                    <h4 className="p-3 bg-gray-200 rounded-md">
                      {companyDetails?.company_name}
                    </h4>
                  </div>
                  <div className="flex flex-col">
                    <label htmlFor="">Email:</label>
                    <h4 className="p-3 bg-gray-200 rounded-md">
                      {companyDetails?.company_email}
                    </h4>
                  </div>
                  <div className="flex flex-col">
                    <label htmlFor="">Service Fee:</label>
                    <h4 className="p-3 bg-gray-200 rounded-md">
                      {serviceFee?.serviceFee}
                    </h4>
                  </div>
                  <div className="flex flex-col">
                    <label htmlFor="">This Month Sales:</label>
                    <h4 className="p-3 bg-gray-200 rounded-md">
                      {Number(serviceFee?.thisMonthSales)?.toLocaleString()}
                    </h4>
                  </div>
                  <div className="flex flex-col">
                    <label htmlFor="">Due Date: </label>
                    <h4 className="p-3 bg-gray-200 rounded-md">
                      {serviceFee?.dueDate}
                    </h4>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default LicenseTable;
